namespace DisbursementWorks {
  export enum API {
    // QueryDisbursementWorksPage(BFF 6.11)：How Disbursement Works 页试算数据。
    // 路径已对齐后端网关(FastEscrow通用中间件，/user/sec 前缀)
    'get_disbursement_works' = '/user/sec/fast-escrow/transaction/query_disbursement_works_page',
  }
}

export default DisbursementWorks;
